import useUser from 'stores/useCustomer';
import { UserTypesWithGuestEnum } from 'types/UserTypesWithGuestEnum';
import { useFeatureFlags } from './useFeatureFlags';

export function useWebshop() {
    const isConsultant = useUser((state) => state.user?.user_type === UserTypesWithGuestEnum.Consultant);
    const isLoggedIn = useUser((state) => state.useLoggedIn());
    const { isGuestCheckoutEnabled } = useFeatureFlags();

    return { isPurchaseDisabled: isConsultant || (isGuestCheckoutEnabled ? false : !isLoggedIn) };
}
